export default {
  counties: [],
  county: null,
  pagination: {}
}
